<div class="support-info-card support-info-card--{{ support.status }}">
  <p class="support-info-card__item"><strong>STATUS:</strong> {{ support.status | supportStatus }}</p>
  <p class="support-info-card__item"><strong>CÓD. CHAMADO:</strong> {{ support.id }}</p>
  <p class="support-info-card__item">
    <strong>DATA DE ABERTURA:</strong> {{ support.created_at | date: "dd/MM/yyyy - HH:mm" }}
  </p>
  <p class="support-info-card__item">
    <strong>ÚLTIMA ATUALIZAÇÃO:</strong> {{ support.updated_at | date: "dd/MM/yyyy - HH:mm" }}
  </p>
</div>
